import React, { memo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

/**
 * Renders the per-recipient ✓/✗ outcome list for one channel (Braze or FCM).
 *
 * Props
 *   badgeLabel: string — channel name shown in the section heading badge
 *   badgeClass: string — `send-test__channel-badge--braze` | `…--fcm`
 *   rows:       Array<{
 *     ok: boolean,
 *     recipient: string,
 *     campaignName?: string,  // Braze: per-campaign result fan-out
 *     error?: string,         // shown on the failure row
 *   }>
 */
const ResultList = ({ badgeLabel, badgeClass, rows }) => {
  if (!rows || rows.length === 0) return null;

  return (
    <div className='send-test__result-section'>
      <h6 className='send-test__result-heading'>
        <span className={`send-test__channel-badge ${badgeClass}`}>
          {badgeLabel}
        </span>
      </h6>
      <ul className='send-test__result-list'>
        {rows.map((row, i) => (
          <li
            key={i}
            className={`send-test__result-row ${
              row.ok
                ? 'send-test__result-row--success'
                : 'send-test__result-row--error'
            }`}
          >
            <FontAwesomeIcon icon={row.ok ? faCheckCircle : faTimesCircle} />
            <span className='send-test__result-row-target'>
              {row.recipient}
              {row.campaignName && (
                <span className='text-muted'> → {row.campaignName}</span>
              )}
            </span>
            {!row.ok && row.error && (
              <span className='send-test__result-row-error'>{row.error}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default memo(ResultList);
